import { Box, Radio, styled, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import config from 'config'
import { Icon } from 'packages/eid-icons'
import { ReactComponent as PlusSquareIconSvg } from '../Resources/collapse.svg'
import { ReactComponent as MinusquareIconSvg } from '../Resources/constrain.svg'
import TreeSubItem from './TreeSubItem'
import { isNilOrEmpty } from 'packages/core'

const getFullImageUrl = (imagePath) => `${config.BASE_EID_URL}${imagePath}`

const StyledListItem = styled('ul')({
    listStyle: 'none',
    paddingLeft: '2.8rem',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    width: '29rem',
    '&  li ul li p': {
        fontWeight: '400 !important',
    },
})

const StyledListContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
})

const StyledListRadioSection = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem',
    width: 'fit-content',
})

const StyledListCollapse = styled(Box)({
    width: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '0.5rem',
})

const StyledRadio = styled(Radio)({
    padding: '0.2rem',
    maxHeight: '2rem',
    '&:hover': {
        backgroundColor: '#d2d2d9',
    },
})

const StyledSearchHighlight = styled('span')({
    color: '#01745f',
    fontWeight: 600,
    textDecoration: 'underline',
})

const TreeListItem = React.memo(
    ({ node, onClick, selected, labelProp, idProp, searchTerm }) => {
        const theme = useTheme()
        const [isOpen, setIsOpen] = useState(
            !isNilOrEmpty(searchTerm) ? true : false,
        )

        const handleClick = () => {
            setIsOpen(!isOpen)
        }

        useEffect(() => {
            if (!isNilOrEmpty(searchTerm)) {
                setIsOpen(true)
            }
        }, [searchTerm])

        const bindName = (fieldName) => {
            const substring = searchTerm

            // Create a regular expression to match the substring
            const regex = new RegExp(`(${substring})`, 'gi')

            // Replace the substring with a span element containing the highlighted style
            const highlightedText = fieldName.replace(
                regex,
                (match) =>
                    `<${StyledSearchHighlight}>${match}</${StyledSearchHighlight}>`,
            )

            return highlightedText
        }

        return (
            <div>
                <div>
                    <StyledListContainer>
                        {/* Check if we  have children then only render the expand icon */}
                        <StyledListCollapse onClick={() => handleClick()}>
                            {node.children.length ? (
                                isOpen ? (
                                    <MinusquareIconSvg />
                                ) : (
                                    <PlusSquareIconSvg />
                                )
                            ) : null}
                        </StyledListCollapse>
                        {/* Radio Selection Button */}
                        <StyledListRadioSection onClick={() => onClick(node)}>
                            <StyledRadio
                                checkedIcon={
                                    <Icon
                                        name="RadioFilled"
                                        color={theme?.palette?.primary?.main}
                                    />
                                }
                                icon={<Icon name="Radio" />}
                                checked={
                                    selected?.[idProp] === node[idProp] ?? false
                                }
                                onClick={() => onClick(node)}
                            />

                            {/* Icon if exist in node */}
                            {node?.iconUrl && (
                                <Box
                                    component="img"
                                    sx={{
                                        maxHeight: '1.6rem',
                                    }}
                                    src={getFullImageUrl(node.iconUrl)}
                                    alt={'icon'}
                                />
                            )}
                            {/* Label */}
                            <Typography
                                variant="body2"
                                sx={{
                                    fontWeight: 'bold',
                                    wordBreak: 'break-all',
                                    paddingLeft: '0.5rem',
                                    color: '#767676',
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: bindName(node[labelProp]),
                                }}
                            />
                            {/* Count */}
                            {node?.children?.length ? (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        marginLeft: '0.5rem',
                                        color: '#919193',
                                    }}
                                >
                                    ({node.children.length})
                                </Typography>
                            ) : null}
                        </StyledListRadioSection>
                    </StyledListContainer>
                </div>
                {isOpen && (
                    <StyledListItem>
                        {node.children.map((childNode) => (
                            <li key={childNode[idProp]}>
                                <TreeSubItem
                                    node={childNode}
                                    labelProp={labelProp}
                                    onClick={onClick}
                                    selected={selected}
                                    idProp={idProp}
                                    searchTerm={searchTerm}
                                />
                            </li>
                        ))}
                    </StyledListItem>
                )}
            </div>
        )
    },
)

export default TreeListItem
